"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.useInitHome = void 0;
var react_1 = __importDefault(require("react"));
var condWeb_1 = require("./WebRoute/condWeb");
var locationPath_1 = require("./WebRoute/useUrlHistory/locationPath");
var useInitHome = function (info) {
    // ----------- set Props
    var setHome = info.setHome, sttSelected = info.sttSelected, setRouteData = info.setRouteData, getData = info.getData;
    // ----------- set Data
    var location = (0, locationPath_1.locationPath)();
    // ----------- set Effects
    var fxSetHome = function () {
        var condHome = setHome;
        var checkBlank = sttSelected && sttSelected !== '';
        if ((0, condWeb_1.condWeb)() && checkBlank) {
            var checkNotEqual = location !== setHome;
            condHome = checkNotEqual ? location : setHome;
            getData(condHome);
        }
        setRouteData(condHome);
    };
    // ----------- set Hooks
    react_1["default"].useEffect(fxSetHome, []);
};
exports.useInitHome = useInitHome;
